import { connect } from 'react-redux'
import { Route, Routes } from 'react-router-dom-v5-compat'
import joinPath from 'lib/join-path'
import { track } from 'lib/analytics'
import { setUserResponse } from '../../actions'
import AdoptionAffirmation from './AdoptionAffirmation/adoption-affirmation'
import AdoptionAge from './AdoptionAge/adoption-age'
import { urlWithChecklistParam } from 'utils'
import withRouter from 'shared/HOC/withRouter'

export const ARRIVAL_AGE_PATH = 'arrival-age'

const Adoption = ({ router, nextPath, onSaveArrivalAge }) => (
  <Routes>
    <Route
      index
      element={
        <AdoptionAffirmation
          nextPath={joinPath(router.location.pathname, ARRIVAL_AGE_PATH)}
        />
      }
    />
    <Route
      path={ARRIVAL_AGE_PATH}
      element={
        <AdoptionAge onSaveArrivalAge={onSaveArrivalAge} nextPath={nextPath} />
      }
    />
  </Routes>
)

const mapDispatchToProps = (dispatch, { router, nextPath }) => ({
  onSaveArrivalAge: (arrivalAge) => {
    const url = urlWithChecklistParam(nextPath)

    track.onboardingQuestionAnswered({
      eventLocation: track.EventLocation.ONBOARDING_MINUS_ADOPTION_AGE,
      answer: arrivalAge,
    })
    dispatch(setUserResponse({ arrivalAge }))
    router.navigate(url)
  },
})

export default withRouter(connect(null, mapDispatchToProps)(Adoption))
